import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  channel: z.string().optional(),
  internalChannelId: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/support/")({
  component: () => null,
  validateSearch: searchSchema,
  beforeLoad: ({ context, search }) => {
    requirePermission(context.user, "read", "internal-channels");
    throw redirect({
      to: "/conversations",
      search: {
        segment: "support",
        channel: search.channel,
        internalChannelId: search.internalChannelId,
      },
    });
  },
});
